export const showNoRepeatingConsole = (text: {current: string}, newTextForConsole: string) => {
  const isNewTextForConsole = text.current !== newTextForConsole;
  if (isNewTextForConsole) {
    // eslint-disable-next-line no-console
    console.log(newTextForConsole);
    text.current = newTextForConsole;
    return true;
  }

  return false;
};
